import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact">
      <h2>Contact Me</h2>
      <p>This is the contact page.</p>
    </div>
  );
}

export default Contact;
